var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { currencyFormat } from "../../lib/misc.functions";
import { useTranslation } from "react-i18next";
import { Api } from "../account/subpages/gameOperations/game.operations.api";
import { env } from "../../definitions/global.vars";
import { Storage } from "../../lib/localstorege.service";
import { useState } from "react";
import i18n from "i18next";
import { member } from "../../store/login.store";
function CashoutDetail(params) {
    var _this = this;
    var t = useTranslation().t;
    var data = params.data || {};
    var isDetail = params.isDetail || false;
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    var _b = useState(false), isLoadingOffer = _b[0], setIsLoadingOffer = _b[1];
    var _c = useState(false), isProcessing = _c[0], setIsProcessing = _c[1];
    var _d = useState(0), cashoutAmount = _d[0], setCashoutAmount = _d[1];
    var _e = useState(''), message = _e[0], setMessage = _e[1];
    var handleInitialClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestData, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoadingOffer(true);
                    setShowModal(true);
                    requestData = {
                        token: Storage.get('token'),
                        coupon_id: data.id,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, Api.start('post', env.list_api + '/order/api/cashout/', requestData, true)];
                case 2:
                    response = _a.sent();
                    if (response.status === false) {
                        setMessage(response.message);
                        return [2 /*return*/];
                    }
                    if (response.status && response.data) {
                        setCashoutAmount(response.data.cashout_amount);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    console.error("Offer Fetch Error:", e_1);
                    setShowModal(false);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingOffer(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var confirmCashout = function () { return __awaiter(_this, void 0, void 0, function () {
        var cashoutOfferData, response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsProcessing(true);
                    cashoutOfferData = {
                        token: Storage.get('token'),
                        coupon_id: data.id,
                        do_cashout: true,
                        amount: cashoutAmount
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Api.start('post', env.list_api + '/order/api/cashout/', cashoutOfferData, true, 30000)];
                case 2:
                    response = _a.sent();
                    if (response.status) {
                        setTimeout(function () {
                            if (member.force_printout) {
                                // OPEN FIS
                                var url = "".concat(env.core_api, "/order/print-betslip/").concat(i18n.resolvedLanguage, "/").concat(data.id, "/?token=").concat(Storage.get('token'));
                                var iframe_1 = document.createElement("iframe");
                                iframe_1.src = url;
                                iframe_1.style.position = "fixed";
                                iframe_1.style.top = "0";
                                iframe_1.style.left = "0";
                                iframe_1.style.width = "100vw";
                                iframe_1.style.height = "100vh";
                                iframe_1.style.border = "none";
                                iframe_1.style.zIndex = "9999";
                                document.body.appendChild(iframe_1);
                                setTimeout(function () {
                                    document.body.removeChild(iframe_1);
                                }, 3000);
                            }
                            setShowModal(false);
                            setIsProcessing(false);
                            params.onSuccess();
                        }, 5000);
                    }
                    else {
                        setIsProcessing(false);
                        alert(response.message || "Bir hata oluştu.");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    setIsProcessing(false);
                    alert(e_2.message || "Sistem hatası");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var overlayStyle = {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex',
        alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    };
    var modalStyle = {
        background: '#1a1a1a', padding: '24px', borderRadius: '12px',
        maxWidth: '400px', width: '90%', textAlign: 'center', color: 'white',
        boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
    };
    var btnBase = {
        padding: '10px 20px', borderRadius: '6px', border: 'none',
        cursor: 'pointer', fontWeight: 'bold', margin: '0 5px'
    };
    return (_jsxs("div", __assign({ className: "dataListEl-open cashout-detail-card" }, { children: [_jsx("button", __assign({ disabled: isProcessing, type: "button", className: "cashout-detail-button ".concat(isDetail ? 'detail' : ''), onClick: handleInitialClick }, { children: t('betslip.cashOut') }), void 0), showModal && (_jsx("div", __assign({ style: overlayStyle }, { children: _jsx("div", __assign({ style: modalStyle }, { children: isLoadingOffer ? (_jsx("div", __assign({ style: { padding: '20px' } }, { children: _jsx("div", { className: "spinner-loader" }, void 0) }), void 0)) : (_jsxs(_Fragment, { children: [_jsx("h3", __assign({ style: { margin: '0 0 15px 0' } }, { children: t('Emin misiniz?') }), void 0), _jsxs("p", __assign({ style: { fontSize: '16px', marginBottom: '25px' } }, { children: [cashoutAmount > 0 && (_jsxs(_Fragment, { children: ["Kuponu ", _jsxs("strong", { children: [" ", currencyFormat(cashoutAmount)] }, void 0), " tutar\u0131yla cashout etmek istiyor musunuz?"] }, void 0)), cashoutAmount === 0 && (_jsx(_Fragment, { children: message }, void 0))] }), void 0), _jsxs("div", __assign({ style: { display: 'flex', justifyContent: 'center' } }, { children: [cashoutAmount > 0 && (_jsx("button", __assign({ style: __assign(__assign({}, btnBase), { backgroundColor: '\'#28a745\'', color: '#fff' }), disabled: isProcessing || cashoutAmount === 0, onClick: confirmCashout }, { children: isProcessing ? t('İşleniyor...') : t('Evet') }), void 0)), !isProcessing && (_jsx("button", __assign({ style: __assign(__assign({}, btnBase), { backgroundColor: '#dc3545', color: '#fff' }), disabled: isProcessing, onClick: function () { return setShowModal(false); } }, { children: t('Vazgeç') }), void 0))] }), void 0)] }, void 0)) }), void 0) }), void 0)), _jsx("style", { children: "\n                .spinner-loader {\n                    border: 4px solid #f3f3f3;\n                    border-top: 4px solid #3498db;\n                    border-radius: 50%;\n                    width: 30px;\n                    height: 30px;\n                    animation: spin 1s linear infinite;\n                    margin: 0 auto;\n                }\n                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }\n            " }, void 0)] }), void 0));
}
export default CashoutDetail;
